import axios from 'axios';

// ─── Base URLs ───────────────────────────────────────────
export const API_BASE = 'https://activity.smartandsafe.com.co/api';
export const METRICS_BASE = 'https://activity.smartandsafe.com.co';

// ─── Configured Axios Instance ───────────────────────────
const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
});

// Request interceptor — auto-attach auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers['X-Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor — handle 401 globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('accessToken');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// ─── Metrics Axios Instance ──────────────────────────────
export const metricsApi = axios.create({
  baseURL: METRICS_BASE,
});

metricsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers['X-Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export default api;
